import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn } from '../interface/generic-interface';

@Injectable()
export class MainNavInfService {

  constructor(private conService: ApiConService) { }

  async getInfoGeralOcorrencias() {
    try {
      const response: JsonReturn = await this.conService.patch('infoGeralOcorrencias');
      return response.response;
    }catch (Error) {
      console.log("CATCH________getInfoGeralOcorrencias");
      console.log(Error);
    }
  }
}
